

import { Card, CardContent } from "@/components/ui/card";
import { Lock, Building2 } from "lucide-react";
import { useI18n } from "@/i18n";

const EnterpriseFeature = () => {
  const { language } = useI18n();

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <Card className="border-2 border-blue-200 bg-gradient-to-br from-blue-50 to-white">
            <CardContent className="pt-12 pb-12">
              <div className="text-center mb-8">
                <div className="inline-flex p-4 rounded-2xl bg-blue-100 mb-6">
                  <Building2 className="w-10 h-10 text-blue-600" />
                </div>
                <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
                  {language === 'en'
                    ? 'Enterprise Exclusive Apps'
                    : '企业专属应用'}
                </h2>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto text-balance">
                  {language === 'en'
                    ? 'Enterprise users get access to exclusive, custom-built apps tailored to your organization\'s needs. After logging in, discover a dedicated section with apps designed specifically for your business.'
                    : <>企业用户登录后，除了基本应用，<br />还可以访问专为您的组织定制的企业专属应用页面。<br />这些应用专门为您的企业需求打造，只有登录后才能浏览。</>}
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-6 mt-10">
                <div className="flex items-start gap-4">
                  <div className="inline-flex p-2 rounded-lg bg-blue-100 mt-1">
                    <Lock className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-2 text-gray-900">
                      {language === 'en' ? 'Secure Access' : '安全访问'}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {language === 'en'
                        ? 'Only authenticated enterprise users can access these specialized apps'
                        : '只有经过身份验证的企业用户才能访问这些专业应用'}
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="inline-flex p-2 rounded-lg bg-blue-100 mt-1">
                    <Building2 className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg mb-2 text-gray-900">
                      {language === 'en' ? 'Custom Built' : '定制开发'}
                    </h3>
                    <p className="text-sm text-gray-600">
                      {language === 'en'
                        ? 'Apps tailored specifically for your organization\'s workflows'
                        : '专为您的组织工作流程量身定制的应用'}
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default EnterpriseFeature;
